/**
 * Extract the URL params as a record
 */
export const getURLParametersRecord = (): Record<string, string> => {
    const params = Object.fromEntries(new URLSearchParams(window.location.search));
    console.log(`getParametersRecord -> params ->`, params);
    return params;
  };

  function isNotProduction() {
    return !window.location.hostname.endsWith('ikhokha.com');
  }
  
  /**
   * For development and testing logs only
   */
  export function devLogging(message: string, data?: unknown, bypass?: boolean, level?: 'error' | 'warn'): void {
    if (bypass || isNotProduction()) {
      const args = [message, data];
      if (level && level === 'error') {
        args.push(`color: red;`);
      } else if (level && level === 'warn') {
        args.push(`color: yellow;`);
      }
      console.log(...args.filter((i) => !!i));
    }
  }